import { cn } from '../../../../../lib/utils';
import MonkeyIcon from '../../../../common/MonkeyIcon';
import type { MonkeyState } from '../types';

// Branded "send to code-monkey" button: dark-blue circle, white monkey face, spins while sending.
export function MonkeyButton({ state, onClick, title }: { state: MonkeyState; onClick: () => void; title: string }) {
  return (
    <button
      onClick={onClick}
      disabled={state === 'loading'}
      title={title}
      className={cn(
        'p-1.5 rounded-full text-white dark:text-white flex items-center justify-center transition disabled:opacity-60',
        state === 'error' ? 'bg-red-600 dark:bg-red-600 hover:bg-red-500 dark:hover:bg-red-500'
          : state === 'done' ? 'bg-green-600 dark:bg-green-600'
          : 'bg-backgroundDarker-dark dark:bg-backgroundDarker-dark hover:opacity-85',
      )}
    >
      <MonkeyIcon className={cn('w-3.5 h-3.5', state === 'loading' && 'animate-spin')} />
    </button>
  );
}
